<template>
  <div>
    <div class="d-flex justify-content-end">
      <button class="btn btn-warning mb-1" @click="showAddProductModal">
        Add Products
      </button>
    </div>
    <div class="modal fade" id="Addproducts" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content custom-modal">
          <div class="modal-header">
            <h5 class="modal-title">Add Product</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div v-if="successmsg" style="color: green">{{ successmsg }}</div>
          
          <div v-if="loader" class="text-center my-4 loader-overlay">
            <div class="fancy-loader"></div>
          </div>

          <div class="modal-body">
            <form @submit.prevent="submitProduct">
              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label">SKU *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="sku"
                    placeholder="SKU"
                  />
                  <small v-if="errors.sku" class="text-danger">{{ errors.sku }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">SKU Category</label>
                  <select v-model="sku_category" class="form-control">
                    <option value="" disabled>Select a Category</option>
                    <option v-for="cat in categories" :key="cat.id" :value="cat.name">
                      {{ cat.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Product Name *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="product_name"
                    placeholder="Product Name"
                  />
                  <small v-if="errors.product_name" class="text-danger">{{
                    errors.product_name
                  }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Brand</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="brand_name"
                    placeholder="Product Brand"
                  />
                  <small v-if="errors.brand_name" class="text-danger">{{
                    errors.brand_name
                  }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Sale Price *</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="sale_price"
                    placeholder="Sale Price"
                    step="any"
                    required
                  />
                  <small v-if="errors.sale_price" class="text-danger">{{
                    errors.sale_price
                  }}</small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Cost Price *</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="cost_price"
                    placeholder="Cost Price"
                      step="any"
                  />
                  <small v-if="errors.cost_price" class="text-danger">{{
                    errors.cost_price
                  }}</small>
                </div>
                <div class="col-md-4">
                <label class="form-label">LSU UOM</label> 
                <select class="form-control" v-model="lsu_uom">
                <option value="">-- Select / Clear Option --</option>
                <option value="Packs">Packs</option> 
                <option value="Eaches">Eaches</option>
                <option value="Milliliters">Milliliters (ML)</option>
                </select>
                </div>

                <div class="col-md-4">
                  <label class="form-label">LSU Factor</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="lsu_factor"
                    placeholder="LSU Factor"
                  />
                  <small v-if="errors.lsu_factor " class="text-danger">  {{ errors.lsu_factor }} </small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">LSU Weight</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="lsu_weight"
                    placeholder="LSU Weight"
                     step="any"
                  />
                  <small v-if="errors.lsu_weight " class="text-danger">  {{ errors.lsu_weight }} </small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">LSU Weight UOM</label>
                 <select  class="form-control" v-model="lsu_weight_uom">
                  <option value="">-- Select / Clear Option --</option>
                   <option value="Ounces" >Ounces</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">LSU Volume</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="lsu_volume"
                    placeholder="LSU Volume"
                     step="any"
                  />
                  <small v-if="errors.lsu_volume " class="text-danger">  {{ errors.lsu_volume }} </small>
                </div>
                <div class="col-md-4">
                  <label class="form-label">LSU Volume UOM</label>
                 <select  class="form-control" v-model="lsu_volume_uom" >
                  <option value="">-- Select / Clear Option --</option>
                  <option value="Milliliters"> 	Milliliters (ML) </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Contains Nicotine</label>
                  <select v-model="contains_nicotine" class="form-control">
                    <option value="" disabled>Select an option</option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Unit Volume</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="unit_volume"
                    placeholder="Unit Volume"
                     step="any"
                   
                  />
                  <small v-if="errors.unit_volume " class="text-danger">  {{ errors.unit_volume }} </small>
                </div>
                <div class="col-md-4">
                <label class="form-label">Unit Volume UOM</label>
                <select class="form-control" v-model="unit_volume_uom">
                  <option value="">-- Select / Clear Option --</option>
                <option value="Milliliters">	Milliliters (ML)</option>
               </select>
               </div>

                <div class="col-md-4">
                  <label class="form-label">Distro</label>
                  <select v-model="distro" class="form-control">
                    <option value="" disabled>Select an option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Customer</label>
                 <!--  <input
                    type="text"
                    class="form-control"
                    v-model="customer"
                    placeholder="Customer"
                     @input="customer = $event.target.value.replace(/[^a-zA-Z\s]/g, '')"
                  /> -->
                  <select v-model="customer" class="form-control">
                    <option value="" disabled>Select an option </option>
                    <option value="Yes" >  Yes</option>
                     <option value="No"> No </option>
                     </select>
                </div>
              </div>
              <div class="text-end mt-1">
                <button type="submit" class="btn btn-success">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from "bootstrap";
import { AddProduct } from "../../End Points/api";
import { GetCategories } from "../../End Points/api";

export default {
  data() {
    return {
      sku: "",
      sku_category: "",
      product_name: "",
      brand_name:"",
      sale_price: 0,
      cost_price: 0,
      lsu_uom: "",
      lsu_factor: 0,
      lsu_weight: null,
      lsu_weight_uom: "",
      lsu_volume: 0,
      lsu_volume_uom: "",
      contains_nicotine: "",
      unit_volume: 0,
      unit_volume_uom: "",
      distro: "",
      customer: "",
      modalInstance: null,
      errors: {},
      loader: false,
      successmsg: "",
      categories: {},
      duplicate_sku_error:""
    };
  },

  methods: {
    successToast(msg) {
      this.$toast.success(msg, { timeout: 4000 });
    },
    errorToast(msg) {
      this.$toast.error(msg, { timeout: 5000 });
    },
    async getCategories() {
      try {
        const res = await GetCategories();
        if (res && res.data) {
          this.categories = res.data;
          console.log("categories", this.categories);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },
    validateForm() {
  this.errors = {};

 
  const salePrice = parseFloat(this.sale_price);
  const costPrice = parseFloat(this.cost_price);

if (!this.sku) {
  this.errors.sku = "SKU is required.";
} else if (this.sku.length > 255) {
  this.errors.sku = "SKU must not exceed 255 characters.";
}
if (this.brand_name && this.brand_name.length > 255) {
  this.errors.brand_name = "Brand name must not exceed 255 characters.";
}

      if (!this.product_name) {
        this.errors.product_name = "Product Name is required";
      }
      else if (this.product_name.length > 255)
      {
        this.errors.product_name = "Product name must not exceed 255 characters."
      }
  
  if (!salePrice || salePrice <= 0 || salePrice > 999999) {
  this.errors.sale_price = "Sales Price is required and must be between 1 and 999999.";
}

if (!costPrice || costPrice <= 0 || costPrice > 999999) {
  this.errors.cost_price = "Cost Price is required and must be between 1 and 999999.";
}
 if (salePrice && costPrice && salePrice < costPrice) {
  this.errors.sale_price = "Sales price must be greater than or equal to the cost price.";
      }
      if (this.lsu_factor) {
        if (this.lsu_factor < 0 || this.lsu_factor > 999999) {
          this.errors.lsu_factor = "LSU Factor must be between 0 and 999999.";
        }
      }
        if (this.lsu_weight) {
     if (this.lsu_weight < 0 || this.lsu_weight > 999999) {
    this.errors.lsu_weight = "LSU Weight must be between 0 and 999999.";
  }
      }
      if (this.lsu_volume) {
        if (this.lsu_volume < 0 || this.lsu_volume > 999999) {
          this.errors.lsu_volume = "LSU Volume must be between 0 and 999999.";
        }
      }
      if (this.unit_volume) {
        if (this.unit_volume < 0 || this.unit_volume > 999999) {
          this.errors.unit_volume = "Unit Volume must be between 0 and 999999.";
        }
      }

  return Object.keys(this.errors).length === 0;
},
    showAddProductModal() {
      this.modalInstance = new bootstrap.Modal(document.getElementById("Addproducts"));
      this.modalInstance.show();
      this.getCategories();
      this.resetForm();
    },

    async submitProduct() {
      if (!this.validateForm()) {
        return;
      }
      this.duplicate_sku_error =""
      this.loader = true;
      try {
        const productData = {
          sku: this.sku,
          sku_category: this.sku_category,
          product_name: this.product_name,
          brand_name:this.brand_name,
          sale_price: this.sale_price,
          cost_price: this.cost_price,
          lsu_uom: this.lsu_uom,
          lsu_factor: this.lsu_factor || 0,
          lsu_weight: this.lsu_weight || 0,
          lsu_weight_uom: this.lsu_weight_uom,
          lsu_volume: this.lsu_volume || 0,
          lsu_volume_uom: this.lsu_volume_uom,
          contains_nicotine: this.contains_nicotine,
          unit_volume: this.unit_volume || 0,
          unit_volume_uom: this.unit_volume_uom,
          distro: this.distro,
          customer: this.customer,
        };

        const response = await AddProduct(productData);

        if (response.status === 201 || response.status === 200) {
          this.successmsg = response.data.message;
          this.successToast("Products added successfully");
          this.$emit("product-added");

    
          const modalEl = document.getElementById("Addproducts");
          const modalInstance = bootstrap.Modal.getInstance(modalEl);
          if (modalInstance) {
            modalInstance.hide();
          }

          this.resetForm();
        } else {
          console.error("Failed to add product.");
        }
      } catch (error) {
        console.error("Add product error:", error);

        if (error.response && error.response.status === 400) {
          const serverErrors = error.response.data.errors;
          this.errors = serverErrors

          if (serverErrors && serverErrors.sku) {
            this.errors.sku = serverErrors.sku[0];
          /*   const modalEl = document.getElementById("Addproducts");
          const modalInstance = bootstrap.Modal.getInstance(modalEl);
          if (modalInstance) {
            modalInstance.hide();
          } */
           /*  this.errorToast("product with this sku already exists."); */
            this.duplicate_sku_error="product with this sku already exists."
          }
          if (serverErrors && serverErrors.product_name) {
            this.errors.product_name = serverErrors.product_name[0];
             }

          else {
            this.errors.general = "Product creation failed. Please check your input.";
          }
        } else {
          this.errors.general = "Something went wrong. Please try again.";
        }
      }
 finally {
        this.loader = false;
      }
    },

    resetForm() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>

<style scoped>
.custom-modal {
  height: auto;
  max-height: 80vh;
  overflow-y: auto;
  padding: 1rem;
  border-radius: 1rem;
  margin: auto;
}
.modal-content {
  width: 80%;
  max-width: 80%;
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.toast-success {
  background-color: #28a745;
}

.toast-error {
  background-color: #dc3545;
  color: white;
}
.fancy-loader {
  width: 60px;
  height: 60px;
  border: 6px solid #e0e0e0;
  border-top: 6px solid #007bff;
  border-radius: 50%;
  animation: slow-spin 1.8s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.3);
}

@keyframes slow-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
